(function (angular, app) {
    'use strict';

    app.service('UserVerificationDialog', ['Dialog', function(Dialog) {
        this.show = show;

        function show(isPostRegistration, classes) {
            return Dialog.show({
                templateUrl: 'template/dialogs/user-verification/index.html',
                controller: 'UserVerificationCtrl as userVerificationCtrl',
                ariaLabelledby: 'user_verification_dialog_title',
                styleClass: 'user-verification-dialog',
                locals: {
                    isPostRegistration: !!isPostRegistration
                },
                classes: classes
            });
        }
    }]);

    app.run(['$rootScope', 'UserVerificationDialog', function ($rootScope, UserVerificationDialog) {
        $rootScope.UserVerificationDialog = UserVerificationDialog;
    }]);

    app.controller('UserVerificationCtrl', [
        'User', 'Api', 'isPostRegistration', 'USER_VERIFICATION_STATUS', 'PHONE_TYPES', 'SpCaptcha',
        function(User, Api, isPostRegistration, USER_VERIFICATION_STATUS, PHONE_TYPES, SpCaptcha) {
            var userVerificationCtrl = this;

            userVerificationCtrl.isPostRegistration = isPostRegistration;
            userVerificationCtrl.showCaptcha = true;
            userVerificationCtrl.captchaIsInvalid = false;
            userVerificationCtrl.send = send;
            userVerificationCtrl.verify = verify;

            _init();

            function _init(setFocus) {
                return User.getData(true).then(function(userData){
                    userVerificationCtrl.userData = userData;
                    userVerificationCtrl.isVerified = userData.verificationStatusId === USER_VERIFICATION_STATUS.VERIFIED;
                    userVerificationCtrl.codeSent = userData.verificationStatusId === USER_VERIFICATION_STATUS.SENT &&
                        userData.verificationCodeExpiration && (new Date(userData.verificationCodeExpiration)) > (new Date());

                    var mobilePhone = angular.filterCollection(userData.phones, function(phone) {
                        return phone.typeVal === PHONE_TYPES.MOBILE || phone.typeVal === PHONE_TYPES.VERIFY;
                    })[0];
                    if (mobilePhone) {
                        userVerificationCtrl.phoneNumber = mobilePhone.phoneNumber;
                    }

                    if (setFocus) {
                        _setFocusOnBody();
                    }
                });
            }

            function send(phoneNumber) {
                return SpCaptcha.getToken('user_verification_send').then(function(recaptchaHash) {
                    return _request({
                        url: '_send-secure',
                        data: {
                            phoneNumber: phoneNumber,
                            recaptchaHash: recaptchaHash
                        }
                    });
                }).then(function() {
                    userVerificationCtrl.verifyError = false;
                    userVerificationCtrl.uniqPhoneError = false;
                    userVerificationCtrl.codeSent = true;
                    userVerificationCtrl.code = '';
                    userVerificationCtrl.captchaIsInvalid = false;
                    _setFocusOnBody();
                }).catch(function(e) {
                    userVerificationCtrl.captchaIsInvalid = false;
                    if (e && e.response) {
                        var errorName = (e.data && e.data.error) || (e.response && e.response.error);
                        if (errorName === 'The given phone number already exists in the system') {
                            userVerificationCtrl.uniqPhoneError = true;
                        }
                    } else {
                        userVerificationCtrl.captchaIsInvalid = true;
                    }
                });
            }

            function verify() {
                return SpCaptcha.getToken('user_verification_verify').then(function(recaptchaHash) {
                    return _request({
                        url: '_verify-secure',
                        data: {
                            code: userVerificationCtrl.code,
                            recaptchaHash: recaptchaHash
                        }
                    }, {
                        withoutToast: true
                    });
                }).then(function() {
                    return _init(true);
                }).catch(function(e) {
                    userVerificationCtrl.verifyError = true;
                    if (e && !e.response) {
                        userVerificationCtrl.captchaIsInvalid = true;
                    }
                });
            }

            function _request(options, apiOptions) {
                userVerificationCtrl.inPrgress = true;

                options.url = '/v2/retailers/:rid/users/:uid/verification/' + options.url;
                options.method = 'POST';
                return Api.request(options, apiOptions).finally(function() {
                    userVerificationCtrl.inPrgress = false;
                });
            }

            /**
             * Accessibility support
             *
             * @private
             */
            function _setFocusOnBody() {
                var dialogBody = document.querySelector('.dialog-wrapper .dialog > .dialog-body');
                dialogBody && dialogBody.focus();
            }
        }
    ]);
})(angular, app);